import React from 'react';
import api from 'api';
import { Icon, FormElement, TextInput } from 'b3';
import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import { withOpenC3Modal } from 'c3';
import { openWizardForIncomingCall, openWizardForUnscheduledCall, openWizardToScheduleMeeting, openWizardToScheduleCall } from '../components/schedule-wizard/logActivityReducer';
import FgCompanyLogo from '../components/clients/FgCompanyLogo'; 
import { clearOutActiveClientContacts } from '../actions/ClientActions';
import { openModal } from '../actions/ModalActions';
import NoteModal from '../components/NoteModal';
import CallButton from './nav-call-buttons/CallButton';

@connect(
    state => ({
        recentlyViewedClients: state.entitySearch.recentlyViewedClients,
        activeClient: state.activeClient.client
    }),
    { openWizardForIncomingCall, openWizardForUnscheduledCall, openWizardToScheduleMeeting, openWizardToScheduleCall, push, clearOutActiveClientContacts, openModal }
)
export default class NavbarCallButtons extends React.Component {
	constructor(props){
		super(props);

		this.state = {
			isDropdownActive: false,
			typeOfClientAction: null
		};
	}
	openWizardForClientActionType = (typeOfClientAction, clientId) => {
		if(typeOfClientAction == 'inCall') {
			return this.props.openWizardForIncomingCall(clientId);
		}
		
		if(typeOfClientAction == 'outCall') {
			return this.props.openWizardForUnscheduledCall(clientId);
		}

		if(typeOfClientAction == 'scheduleMeeting') {
			return this.props.openWizardToScheduleMeeting(clientId);
		}

		if(typeOfClientAction == 'scheduleCall') {
			return this.props.openWizardToScheduleCall(clientId);
		}
	}
	handleActionButtonClick({typeOfClientAction}) {
		var { pathname } = window.location;
		var pathNameArray = pathname.split('/');

		var isOnClientPage = pathname.includes('client') && pathNameArray.length == 3;

		if(isOnClientPage) {
			if(typeOfClientAction == 'addNote') {
				this.addNote(this.props.activeClient.id);
			} else {
				this.openWizardForClientActionType(typeOfClientAction);
			}
		} else {
			this.setState({
				typeOfClientAction, 
				isDropdownActive: ! this.state.isDropdownActive 
			});	
		}
	}
	addNote(clientId) {
		this.props.openModal(NoteModal, {clientId});
	}
	onSelectClient(clientId) {
		this.setState({isDropdownActive: false});

		this.props.clearOutActiveClientContacts({type: 'CLEAR_OUT_ACTIVE_CLIENT_CONTACTS'});

		var { typeOfClientAction } = this.state;

		if(typeOfClientAction == 'addNote') {
			this.addNote(clientId);
		} else {
			this.openWizardForClientActionType(typeOfClientAction, clientId);
		}
	}
	handleCallIn(){ 
		this.setState({ isDropdownActive: 'call-in' }); 
	}
	render() {
		var { isDropdownActive, typeOfClientAction } = this.state;

		return (
			<div className="callButtons">
				<div style={{marginRight: 10, display: 'flex' }}>
					<CallButton 
						icon="call-in"
						label="Log incoming call"
						shortcutKey="i"
						onClick={ () => this.handleActionButtonClick({typeOfClientAction: 'inCall'}) } />
					<CallButton
						icon="call-out"
						label="Log call made"
						shortcutKey="o"
						onClick={ () => this.handleActionButtonClick({typeOfClientAction: 'outCall'}) } />
					<CallButton
						icon="note-paper-edit"
						label="Add note"
						shortcutKey="n"
						onClick={ () => this.handleActionButtonClick({typeOfClientAction: 'addNote'}) } />
					<CallButton 
						icon="contacts-1"
						label="Schedule Meeting"
						shortcutKey="m"
						onClick={ () => this.handleActionButtonClick({typeOfClientAction: 'scheduleMeeting'}) } />
					<CallButton 
						icon="call-1"
						label="Schedule Call"
						shortcutKey="p"
						onClick={ () => this.handleActionButtonClick({typeOfClientAction: 'scheduleCall'}) } />
				</div>

				{isDropdownActive && 
					<div className="dropdown open">
						<div className="dropdown-menu">
							<SearchLeadsPanel
								typeOfClientAction={typeOfClientAction}
								onSelectClient={this.onSelectClient.bind(this)}
								recentlyViewedClients={this.props.recentlyViewedClients}
							/>
                        </div>
					</div>
				}
			</div>
		);
	}
}

@connect(
    state => ({
        activeClient: state.activeClient.client
    })
)
@withOpenC3Modal
class SearchLeadsPanel extends React.Component {
	constructor(props){
		super(props);

		this.state = {
			results: [],
			searchText: null
		};
	}

	onBack(){
		this.setState({ active: 'searchLeads' });
	}

	onSearchChange(searchText){
		api.post('entity_search', {searchText: searchText})
        .then(searchResponse => {
            this.setState({
                results: searchResponse.value,
                searchText: searchText
            });
        });
	}

	render(){
		var leadItemsMaxHeight = window.innerHeight - 295;
		var results = this.state.searchText ? this.state.results : this.props.recentlyViewedClients;

		var titleTextFromActionType = (typeOfClientAction) => {
			if(typeOfClientAction == 'scheduledMeeting')
				return 'Which client is the meeting for?';
			
			if(typeOfClientAction == 'inCall')
				return 'Which client called you?';

			if(typeOfClientAction == 'scheduleCall')
				return 'Which client is the call for?';

			return 'Which client did you call?';
		};

		var titleText = titleTextFromActionType(this.props.typeOfClientAction);

		return(
			<div className="content">
				<div className="searchLeads">
					<h4>{titleText}</h4>
					<FormElement icon="magnifier">
						<TextInput initialValue="" placeholder="Search for a client" onChange={val => this.onSearchChange(val)} autoFocus={true}/>
					</FormElement> 

					<div className="lead-items" style={{maxHeight: leadItemsMaxHeight}}>
						{results.map((client, i) => 
							<ClientCard onSelectClient={this.props.onSelectClient} client={client} key={i} />
						)}
					</div>
				</div>
			</div>
		);
	}
}

class ClientCard extends React.Component {
	getLabel(){
		var entity = this.props.client;
	    var { status } = entity;

	    if(status == 'Dud') {
	        return <span className="label label-danger pull-right">Dud</span>
	    }

	    if(entity.isPaying) {
	        return <span className="label label-success pull-right">Paying</span>
	    }

	    if (entity.companyOnTrial){
	        return <span className="label label-primary pull-right">On Trial</span>
	    }
	    if (entity.trialExpired){
	        return <span className="label label-danger pull-right">Trial Expired</span>
	    }

	    return null;
	}
	selectClient() {
		var { onSelectClient, client } = this.props;
		onSelectClient(client.clientId);
	}
	render(){
		var { client } = this.props;
		var label = this.getLabel();

		return(
	 		<div className="lead-card" key={client.fergusId} onClick={this.selectClient.bind(this)}>
	 			<div className="lead-card__logo">
	 				<FgCompanyLogo fergusId={client.fergusId}/>
	 			</div>
	 			<div className="lead-card__content">
	 				{label}
	 				<h4>{client.entityName} <span className="id">#{client.publicId}</span></h4>
	 				<p>
	 					<span style={{marginRight: 15}}><Icon icon="trophy" filled size="16" /> 12,345</span>
	 					<span><Icon icon="pencil-2" filled size="16" /> 12/05/2016</span>
	 				</p>
	 				<p>Assigned to: Andrew Poh</p>
	 			</div>
	 		</div>
	 	);
	}
}


// WEBPACK FOOTER //
// ./app/components/NavbarCallButtons.js